import { render, staticRenderFns } from "./EditProductImage.vue?vue&type=template&id=0617ea2f&scoped=true&"
import script from "./EditProductImage.vue?vue&type=script&lang=js&"
export * from "./EditProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617ea2f",
  null
  
)

export default component.exports